import axios from 'axios';
import { baseUrl } from '@/config';

const PREFIX_URL = '/settings/oper/event-predict-settings';
export default {
  /**
   * 이벤트 예측 자원 설정을 위한 목록을 조회한다.
   * @author yelim
   */
  getSettingEventPredictRscByTree(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-setting-event-predict-rsc-by-tree.do`, params);
  },
  /**
   * 예측 자원으로 선택할 항목을 조회한다.
   * @author yelim
   */
  getSettingEventPredictRsc(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-setting-event-predict-rsc.do`, params);
  },
  /**
   * 선택 장비에 예측 자원을 설정한다.
   * @author yelim
   */
  setSettingEventPredictRsc(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-setting-event-predict-rsc.do`, params);
  },
  /**
   * 이벤트 예측 자원으로 설정된 관리 대상 트리를 조회한다.
   * @author yelim
   */
  getPredictTargetObjTree(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-predict-target-obj-tree.do`, params);
  },
  /**
   * 사전 예측 이벤트 목록을 조회한다.
   * @author yelim
   */
  getPredictEventHist(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-predict-event-hist.do`, params);
  },
  setConfirmPredictEvent(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-confirm-predict-event.do`, params);
  },
  getPredictEventInfoExcelName(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-predict-event-info-excel-name.do`, params);
  },
  getRscLearnDataList(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-rsc-learn-data-list.do`, params);
  },
  /**
   * 장비에 설정된 이벤트 예측 대상 자원 목록을 조회한다.
   * @author Ju
   * @param  {Number} objId
   * @return {[type]}       [description]
   */
  getPredictTargetRscList(objId) {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-predict-target-rsc-list.do`, { params: { objId } });
  },
  /**
   * 파라미터로 전달한 hashkeyId와 예측 날짜에 대한 학습 데이터 설정이 있는지 확인한다.
   * @author Ju
   * @param  {Number} hashkeyId
   * @param  {Date} predictDatetime
   * @return {[type]}                 [description]
   */
  checkDuplicatePredictCustomLearnData(hashkeyId, predictDatetime) {
    return axios.post(`${baseUrl}${PREFIX_URL}/check-duplicate-predict-custom-learn-data.do`, { hashkeyId, predictDatetime });
  },
  /**
   * 학습 데이터 설정을 추가한다.
   * @author Ju
   * @param  {Object} params [description]
   */
  addPredictCustomLearnData(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/add-predict-custom-learn-data.do`, params);
  },
  /**
   * 학습 데이터 설정을 수정한다.
   * @author Ju
   * @param  {Object} params [description]
   */
  updatePredictCustomLearnData(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/update-predict-custom-learn-data.do`, params);
  },
  setRscLearnDataSetting(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/set-rsc-learn-data-setting.do`, params);
  },
  deleteCustomLearnDataSet(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/delete-custom-learn-data-set.do`, params);
  },
  getPredictRscCount() {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-predict-rsc-count.do`);
  },
  getMaxPredictCoverage() {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-max-predict-coverage.do`);
  },
  getPredictTargetObjDefine() {
    return axios.get(`${baseUrl}${PREFIX_URL}/get-predict-target-obj-define.do`);
  },
  getPredictTargetObjInfo(params) {
    return axios.post(`${baseUrl}${PREFIX_URL}/get-predict-target-obj-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/event-predict-settings.js